import { Box, Button, Collapse, Divider, Flex, HStack, Heading, IconButton, Image, Spacer, StackDivider, Text, Tooltip, VStack, useDisclosure } from "@chakra-ui/react";
import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide';
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Components
import SlideModal from "../../Components/Slide/SlideModal";

// Icons
import { IconRoaming, IconTeSumo, IconConsumo, IconRedesSociales, IconLlamando, IconChat, IconSatelite, IconSimCard, Iconsatelital } from "../../Assets/MOVIL/Icons";
import { Icon5G, IconArrowRight, IconCheck, IconCheckSimple, IconEquipo, LogoEntelPos } from "../../Assets/GENERALES/Icons";
import { IconMaleta, IconUsuarios } from "../../Assets/HOGAR/Icons";
import { IoInformationCircleOutline } from "react-icons/io5";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { FiPhoneCall } from "react-icons/fi";

// Images
import MovilDownMovil from '../../Assets/MOVIL/Banner-Inferior-Mobile.webp';
import MovilDown from '../../Assets/MOVIL/Banner-Inferior-Desktop.webp';
import BannerDk from '../../Assets/MOVIL/ImagenBanner-Desktop.webp';
import BannerMb from '../../Assets/MOVIL/ImagenBanner-Movil.webp';
import latam from '../../Assets/MOVIL/latam.webp';

// Styles
import '@splidejs/react-splide/css/sea-green';
import '@splidejs/react-splide/css/skyblue';
import './style.css';

const Movil = () => {

    const [precioNormalSolicitado, setPrecioNormalSolicitado] = useState('');
    const [precioSolicitado, setPrecioSolicitada] = useState('');
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [planSolicitado, setPlanSolicitada] = useState('');
    const [typePlan, setTypePlan] = useState('portabilidad');
    const [descuentoPlan, setDescuentoPlan] = useState('');
    const [isBanner, setIsBanner] = useState(false);
    const [id, setId] = useState('');

    const { isOpen, onToggle } = useDisclosure();

    const navigate = useNavigate();

    const planes = [
        {
            id: '2',
            planid: 'PO_POS_OO_17196',
            recomendado: 0,
            plan: 'Te Sumo 5G',
            iconUno: <IconLlamando />,
            infoUno: 'Minutos libres',
            iconDos: <IconChat />,
            infoDos: 'RRSS y música libre',
            gigas: '800 Gigas',
            gigas2: '',
            precioNormal: '16.990',
            dcto: typePlan === 'portabilidad' ? '30%' : '30%',
            tiempoDcto: 'Por 6 meses',
            precio: typePlan === 'portabilidad' ? '11.893' : '11.893',
            valorPlanesAdicionales: typePlan === 'portabilidad' ? '7.693' : '5.495',
            valorPlanesAdicionalesNormal: typePlan === 'portabilidad' ? '7.693' : '7.693',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='20px' />,
                    info: '200 SMS satelitales'
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>800 Gigas</b> de navegación y RRSS libres'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Minutos libres'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
        {
            id: '3',
            planid: 'PO_POS_OO_21104',
            recomendado: 1,
            plan: 'Te Sumo 5G',
            millas: '2.000',
            iconUno: <IconLlamando />,
            infoUno: 'Minutos libres',
            iconDos: <IconChat />,
            infoDos: 'RRSS y música libre',
            gigas: '1.000 Gigas',
            gigas2: '',
            precioNormal: '19.990',
            dcto: typePlan === 'portabilidad' ? '30%' : '30%',
            tiempoDcto: 'Por 6 meses',
            precio: typePlan === 'portabilidad' ? '13.993' : '13.993',
            valorPlanesAdicionales: typePlan === 'portabilidad' ? '8.393' : '5.995',
            valorPlanesAdicionalesNormal: typePlan === 'portabilidad' ? '8.393' : '8.393',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>WhatsApp Libre, </b> 200 SMS satelitales'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='20px' />,
                    info: `<b>Acumula hasta 2.000 Millas LATAM Pass</b>`,
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>1.000 Gigas</b> de navegación y RRSS libres'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>Roaming</b> WhatsApp Libre'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Minutos libres'
                },
                {
                    id: 6,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
        
        {
            id: '4',
            planid: 'PO_POS_OO_12936',
            recomendado: 0,
            plan: 'Te Sumo 5G',
            millas: '3.000',
            iconUno: <IconConsumo color='#212121' />,
            infoUno: 'Gigas libres',
            iconDos: <IconRoaming color='#212121' size='20' />,
            infoDos: 'Roaming WhatsApp',
            gigas: 'Libre Full',
            gigas2: '',
            precioNormal: '24.990',
            dcto: typePlan === 'portabilidad' ? '30%' : '30%',
            tiempoDcto: 'Por 6 meses',
            precio: typePlan === 'portabilidad' ? '17.493' : '17.493',
            valorPlanesAdicionales: typePlan === 'portabilidad' ? '8.393' : '5.995',
            valorPlanesAdicionalesNormal: typePlan === 'portabilidad' ? '8.393' : '8.393',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='16px' />,
                    info: '<b>WhatsApp Libre, 500 MB</b> en apps compatibles, 200 SMS satelitales'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='16px' />,
                    info: `<b>Acumula hasta 3.000 Millas LATAM Pass</b>`,
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='16px' />,
                    info: 'Navegación libres'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='16px' />,
                    info: '<b>Roaming:</b> 7GB navegación + WhatsApp Libre + 20 min + 20 SMS'
                },
                {
                    id: 6,
                    icon: <IconCheckSimple size='16px' />,
                    info: 'Minutos libres'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='16px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
        {
            id: '5',
            planid: 'PO_POS_OO_17456',
            recomendado: 0,
            plan: 'Te Sumo 5G',
            millas: '5.000',
            iconUno: <IconConsumo color='#212121' />,
            infoUno: 'Gigas libres',
            iconDos: <IconRoaming color='#212121' size='20' />,
            infoDos: '3GB + WSP + 20Min',
            gigas: 'Libre con Roaming',
            gigas2: '',
            precioNormal: '29.990',
            dcto: typePlan === 'portabilidad' ? '30%' : '30%',
            tiempoDcto: 'Por 6 meses',
            precio: typePlan === 'portabilidad' ? '20.993' : '20.993',
            valorPlanesAdicionales: typePlan === 'portabilidad' ? '8.393' : '5.995',
            valorPlanesAdicionalesNormal: typePlan === 'portabilidad' ? '8.393' : '8.393',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>WhatsApp Libre, 1GB</b> en apps compatibles, 200 SMS satelitales'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='20px' />,
                    info: `<b>Acumula hasta 5.000 Millas LATAM Pass</b>`,
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Navegación <b>libre</b>'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>Roaming:</b> 15GB navegación + Whatsapp Libre + 20 min + 20 SMS'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Minutos libres'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
        {
            id: '6',
            planid: 'PO_POS_OO_14116',
            recomendado: 0,
            plan: 'Te Sumo 5G',
            millas: '8.000',
            iconUno: <IconConsumo color='#212121' />,
            infoUno: 'Gigas libres',
            iconDos: <IconRoaming color='#212121' size='20' />,
            infoDos: '10GB + WSP + 40Min',
            gigas: 'Libre con Roaming Pro',
            gigas2: '',
            precioNormal: '39.990',
            dcto: typePlan === 'portabilidad' ? '30%' : '30%',
            tiempoDcto: 'Por 6 meses',
            precio: typePlan === 'portabilidad' ? '27.993' : '27.993',
            valorPlanesAdicionales: typePlan === 'portabilidad' ? '8.393' : '5.995',
            valorPlanesAdicionalesNormal: typePlan === 'portabilidad' ? '8.393' : '8.393',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>WhatsApp Libre, 3GB</b> en apps compatibles, 200 SMS satelitales'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='20px' />,
                    info: `<b>Acumula hasta 8.000 Millas LATAM Pass</b>`,
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Navegación <b>libre</b>'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>Roaming: </b>30GB navegación + WhatsApp Libre + 40 min + 40 SMS'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Minutos libres'
                },
                {
                    id: 5,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
        {
            id: '1',
            planid: 'PO_POS_OO_17176',
            recomendado: 0,
            plan: '5G',
            gigas: '400 Gigas',
            iconUno: <IconLlamando />,
            infoUno: '1.000 Minutos',
            iconDos: <IconChat />,
            infoDos: 'RRSS y música libre',
            gigas2: '',
            precioNormal: '',
            dcto: '0%',
            tiempoDcto: 'Por 6 meses',
            precio: '13.990',
            valorPlanesAdicionales: '13.990',
            valorPlanesAdicionalesNormal:  '13.990',
            items: [
                {
                    id: 1,
                    icon: <IconCheckSimple size='20px' />,
                    info: '200 SMS satelitales'
                },
                {
                    id: 2,
                    icon: <IconCheckSimple size='20px' />,
                    info: '<b>400 Gigas</b> de navegación y RRSS libres'
                },
                {
                    id: 3,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Habla hasta <b>1.000 Minutos</b>'
                },
                {
                    id: 4,
                    icon: <IconCheckSimple size='20px' />,
                    info: 'Compatible con eSIM'
                },
            ]
        },
    ];

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
    
    let campaignid = urlParams.get('campaignid');
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let gclid = urlParams.get('gclid');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    // const openNewPage = (id, view, plan='', precio='', precioNormal='', descuento='', idPlan='') => {
    //     window.dataLayer.push({
    //         'event': 'GARDevent',
    //         'eventCategory': `entel ofertas - card plan`,
    //         'eventAction':'click to action',
    //         'eventLabel': 'lo quiero',
    //         'origen':'entel',
    //         'segmento':'po',
    //         'mercado':'pe',
    //         'eventPlan': plan.toLowerCase(),
    //         'product_id': idPlan,
    //         'price': precio.replace(/[$.]/g, ''),
    //         'plan_subprice': precioNormal.replace(/[$.]/g, ''),
    //         'type_offer': descuento.replace('%', 'porciento dcto'),
    //         'position': id,
    //         'variant': 'formulario card movil',
    //     });

    //     navigate(`/entel-demo/contratacion?planId=${id}&view=${view}`);
    // };

    // target.id, 'Movil', target.gigas, target.precio, target.precioNormal, target?.dcto, target?.planid

    const openSlide = (view, targetId, segment, targetGigas, targetPrecio, targetPrecioNormal, targetDcto, targetPlanid) => {
        if (view !== 'Banner') {
            window.dataLayer.push({
                'event': 'GARDevent',
                'eventCategory': `entel ofertas - card plan`,
                'eventAction':'click to action',
                'eventLabel': 'lo quiero',
                'origen':'entel',
                'segmento':'po',
                'mercado':'pe',
                'eventPlan': targetGigas,
                'product_id': targetPlanid,
                'price': targetPrecio.replace(/[$.]/g, ''),
                'plan_subprice': targetPrecioNormal.replace(/[$.]/g, ''),
                'type_offer': targetDcto.replace("%", " porciento dcto"),
                'position': targetId,
                'variant': 'formulario card movil',
            });

            // navigate(`${enviroments.urlBase}/contratacionMovil?planId=${targetId}&oda=entel-ofertas-planes-moviles_card${gclid ? `&gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)

            setId(typePlan === 'linea_nueva' ? `Movil Linea Nueva Form Plan ${targetId}` : `Movil Form Plan ${targetId}`);
            setPrecioNormalSolicitado(targetPrecioNormal);
            setDescuentoPlan(targetDcto);
            setPrecioSolicitada(targetPrecio);
            setPlanSolicitada(targetGigas);
            setIsBanner(false);
        } else {
            window.dataLayer.push({
                event: "GARDevent",
                eventCategory: "entel ofertas - banner principal",
                eventAction: "click to action",
                eventLabel: "lo quiero",
                origen: "entel",
                segmento: "po",
                mercado: "pe",
                description: "suma planes adicionales por 3297 cu",
                variant: "formulario banner principal movil"
            });

            setId('form_banner_movil');
            setPrecioNormalSolicitado('');
            setDescuentoPlan('');
            setPrecioSolicitada('');
            setPlanSolicitada('Formulario Banner');
            setIsBanner(true);
        }
        
        setOpenSlideModal(true);
    };

    return (
        <>
            {/* Banner */}
            <Box position="relative" w="100%" h={['232px','232px','280px','280px','280px']} onClick={() => openSlide('Banner')}>
                {/* Imagen como LCP */}
                {/* <Image 
                    src={BannerDk} 
                    srcSet={`${BannerMb} 768w, ${BannerDk} 1024w`} 
                    sizes="(max-width: 768px) 100px, 1024px"
                    alt="Banner promociones Entel" 
                    objectFit="cover"
                    objectPosition='right'
                    w="100%" 
                    h="100%" 
                    loading="eager"
                /> */}
                <picture>
                    <source
                        media="(max-width: 768px)"
                        srcSet={BannerMb}
                    />

                    <Image
                        src={BannerDk}
                        alt="Banner promociones Entel"
                        objectFit="cover"
                        objectPosition="right"
                        w="100%"
                        h="100%"
                        loading="eager"
                    />
                </picture>

                {/* Contenido encima del banner */}
                <Flex position="absolute" top="0" right='0' mx='auto' left="0"  alignItems='center' h="100%" flexDirection="row" px="5">
                    <Box my="auto" color="white" w={["100%","100%","75%","50%","50%"]}>

                        <Box mt='4' mb='2'>
                            <svg width="219" height="48" viewBox="0 0 219 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M39.0206 13.133C38.6297 12.8628 38.029 12.9088 37.6841 13.2249L35.4567 15.2627C35.1089 15.5846 35.1376 16.0761 35.517 16.352C35.517 16.352 38.9516 18.8698 38.9516 24.2847C38.9516 29.6996 35.3359 32.3725 35.3359 32.3725C34.968 32.6743 34.9566 33.1802 35.3043 33.4992L37.5117 35.5054C37.8566 35.8215 38.463 35.8675 38.8539 35.6002C38.8539 35.6002 44.0389 32.0765 44.0389 24.3048C44.0389 16.5331 39.0235 13.1387 39.0235 13.1387" fill="#FF3D00"/>
                                <path d="M17.5622 25.8135C17.5622 25.8135 16.9184 25.7532 16.9184 26.2676C16.9184 29.2021 19.1085 31.2888 22.5402 31.2888C25.0925 31.2888 26.1818 30.6823 27.7252 29.5269C28.0845 29.2567 28.4639 29.0067 28.7599 29.3229C28.9611 29.5413 31.6685 32.0389 31.6685 32.0389C32.0077 32.3551 31.9157 32.7345 31.5507 33.042C31.1914 33.3467 27.1446 36.491 22.4942 36.491C16.4068 36.491 10.5723 33.8439 10.5723 23.8763C10.5723 15.846 15.1249 11.3105 21.7987 11.3105C28.9726 11.3105 33.028 16.3173 33.028 23.0716V24.7817C33.028 25.4772 32.4618 25.8164 31.9962 25.8164H17.5622V25.8135ZM26.1042 18.9644C25.4173 17.5015 23.9802 16.4122 21.8044 16.4122C19.6287 16.4122 18.1974 17.5015 17.5018 18.9644C17.1023 19.8611 16.9558 20.5251 16.9069 21.6086H26.702C26.6531 20.5251 26.5008 19.864 26.1071 18.9644" fill="white"/>
                                <path d="M57.1748 10L57.1748 37.794" stroke-width="0.524428" stroke="#66686C"/>
                                <path d="M69.7676 27.6601H72.7195C72.8263 28.5594 73.1167 29.2023 73.5867 29.5718C74.0566 29.9456 74.7486 30.1314 75.6713 30.1314C77.4271 30.1314 78.3092 29.4095 78.3092 27.9677C78.3092 27.3184 78.1362 26.8228 77.7902 26.4811C77.4378 26.1393 76.8846 25.9044 76.1242 25.7826L74.5756 25.5135C71.613 25.0222 70.1264 23.5014 70.1264 20.9468C70.1264 19.4261 70.6305 18.2257 71.6365 17.335C72.6426 16.4464 73.9797 16 75.6436 16C77.3075 16 78.5442 16.4315 79.484 17.2858C80.4281 18.1402 80.9599 19.3492 81.0881 20.902H78.0914C78.0465 20.1074 77.8116 19.5329 77.4036 19.1633C76.9892 18.8002 76.3869 18.6165 75.5987 18.6165C74.8105 18.6165 74.1783 18.8002 73.7703 19.1762C73.356 19.5457 73.1509 20.0583 73.1509 20.7076C73.1509 21.2779 73.3303 21.7307 73.6977 22.0597C74.0608 22.395 74.6311 22.63 75.4086 22.7752L77.1473 23.0828C79.971 23.5912 81.385 25.129 81.385 27.6943C81.385 29.3433 80.8531 30.6056 79.8023 31.4728C78.745 32.3443 77.3267 32.78 75.5325 32.78C73.7383 32.78 72.4012 32.3378 71.4187 31.46C70.4297 30.5928 69.8808 29.3198 69.7697 27.658L69.7676 27.6601Z" fill="white"/>
                                <path d="M95.3859 18.9523V32.648H92.2439V18.9523H88.0575V16.2461H99.5724V18.9566H95.3859V18.9502V18.9523Z" fill="white"/>
                                <path d="M108.319 29.4655L107.324 32.6523H104.043L109.868 16.2461H112.411L118.264 32.6523H114.955L113.96 29.4655H108.319ZM111.132 20.5735L109.158 26.8788H113.127L111.132 20.5735Z" fill="white"/>
                                <path d="M128.593 25.9946V32.6523H125.475V16.2461H131.708C133.305 16.2461 134.587 16.6882 135.537 17.5661C136.488 18.4483 136.962 19.6401 136.962 21.1438C136.962 22.2225 136.71 23.1345 136.212 23.8778C135.715 24.6211 134.993 25.1701 134.059 25.5161L137.631 32.648H134.042L130.928 25.9903H128.591V25.9967L128.593 25.9946ZM131.539 23.4015C132.265 23.4015 132.831 23.205 133.239 22.8205C133.641 22.4297 133.844 21.87 133.844 21.1438C133.844 20.4795 133.636 19.9477 133.228 19.5504C132.814 19.1531 132.25 18.9587 131.541 18.9587H128.589V23.4037H131.541L131.539 23.4015Z" fill="white"/>
                                <path d="M148.332 16.2461V29.9418H155.515V32.6523H145.22V16.2461H148.334H148.332Z" fill="white"/>
                                <path d="M166.46 16.2461V32.6523H163.346V16.2461H166.46Z" fill="white"/>
                                <path d="M187.387 32.6523H184.273L178.231 22.3998V32.6523H175.116V16.2461H178.231L184.273 26.52V16.2461H187.387V32.6523Z" fill="white"/>
                                <path d="M208.734 16.2461H205.094L199.165 24.4182V16.2461H196.047V32.6523H199.165V24.4802L205.094 32.6523H208.734L202.781 24.446L208.734 16.2461Z" fill="white"/>
                            </svg>
                        </Box>

                        <Heading as="h1" fontWeight="400" fontSize={['25px','25px','42px']} className="General" lineHeight="1">
                            Un plan que te acompaña <b>en todas</b>
                        </Heading>
                        <Text className="General" mt="3" fontSize={['15px']} lineHeight='1'>Planes móviles con <b>cobertura satelital</b></Text>

                        
                        <Button borderRadius="30" mt="3" onClick={() => openSlide('Banner')} w={{base: '60%', md: "40%"}} size={['sm','sm','md']} className="General" bg="white" color="#002FFD" _hover={{color:'white', bg:'#002FFD'}}>
                            Quiero que me llamen
                        </Button>
                    </Box>
                    <Spacer />
                </Flex>
            </Box>

            {/* Selector */}
            {/* <Flex w={['95%','95%','90%']} mx="auto" mt={['8','8','12']} borderBottom="1px solid #E2E8F0">
                <Box 
                    flex="1" 
                    textAlign="center" 
                    pb="2" 
                    cursor="pointer" 
                    borderBottom={typePlan === 'portabilidad' ? '2px solid #002EFF' : 'none'}
                    onClick={() => setTypePlan('portabilidad')}
                >
                    <Text 
                        className="Subtitle" 
                        fontSize={['16px','16px','16px']}
                        color={typePlan === 'portabilidad' ? '#002EFF' : '#000'}
                    >
                        Portabilidad
                    </Text>
                    <Text className="General" fontSize={['12px','12px','14px']} color={typePlan === 'portabilidad' ? '#002EFF' : '#000'}>50% dcto.</Text>
                </Box>
                <Box 
                    flex="1" 
                    textAlign="center" 
                    pb="2" 
                    cursor="pointer" 
                    borderBottom={typePlan === 'linea_nueva' ? '2px solid #002EFF' : 'none'}
                    onClick={() => setTypePlan('linea_nueva')}
                >
                    <Text 
                        className="Subtitle" 
                        fontSize={['16px','16px','16px']}
                        color={typePlan === 'linea_nueva' ? '#002EFF' : '#000'}
                    >
                        Línea nueva
                    </Text>
                    <Text className="General" fontSize={['12px','12px','14px']} color={typePlan === 'linea_nueva' ? '#002EFF' : '#000'}>30% dcto.</Text>
                </Box>
            </Flex> */}

            {/* Planes */}
            <Box>
                <Box id="id-secction-slider-plan-position-moviles" mx="auto" pb={[20,20,5,5,5]} w={['90%','90%','90%','90%','90%']} pt={['5','5','8','8','8']}>
                    <Splide
                        hasTrack={false}
                        options={{
                            perMove: 1,
                            type: 'slide',
                            pagination: true,
                            autoplay: false,
                            gap: '15px',
                            autoWidth: true,
                        }}
                    >
                        <SplideTrack className='tarjets-planes-movil'>
                            {
                                planes.map((target, i) => {
                                    return (
                                        target.recomendado === 1 
                                        ?
                                            <SplideSlide key={target.id}>
                                                <Box key={target.id} bg='white' p='1px' borderRadius='10'>
                                                    <Box bg='#10069F' textAlign='center' borderTopRadius='10' color='white'>
                                                        <Text className='Subtitle' fontSize='lg'><b>Plan</b> Destacado</Text>
                                                    </Box>
                                                    <Box border='1px solid #BBB' borderBottomRadius="10" width='340px'>
                                                        {/* Cobertura Satelital */}
                                                        {/* <Flex justify='end' pt='3' pr='3'>
                                                            <Flex align='center' gap='5px' px='2' bg='#F3F5FF' border='1px solid #0022BF' borderRadius='5px'>
                                                                <IconSatelite size='12' />
                                                                <Text className='General' fontSize='sm'>Cobertura Satelital</Text>
                                                            </Flex>
                                                        </Flex> */}

                                                        {
                                                            target?.millas
                                                                ? <Flex justify='end' pt='3' pr='3'>
                                                                    <Text className="General" bg='#4C44B7' color='white' fontSize='sm' px='2' border='1px solid #4C44B7' borderRadius='5px'>
                                                                        {target?.millas} Millas LATAM Pass
                                                                    </Text>
                                                                </Flex>
                                                                : ''
                                                        }

                                                        {/* Header Target */}
                                                        <Box px="4" pt="4" borderRadius="10" display={'block'}>
                                                            <Heading className="Subtitle" textAlign='left' fontSize='2xl'>
                                                                Plan {target.gigas} {target.gigas2}
                                                            </Heading>
                                                        </Box>

                                                        {/* Body Target */}
                                                        <Box px="4" mb="3">
                                                            {
                                                                target.precioNormal
                                                                && <Box display={'block'}>
                                                                    <HStack mt='2' spacing='0' >
                                                                        <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderLeftRadius='5px'>
                                                                            {target.dcto} dcto.
                                                                        </Text>
                                                                        {/* <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='5px'>
                                                                            {target.tiempoDcto}
                                                                        </Text> */}
                                                                        <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='4px'>
                                                                            Oferta Online
                                                                        </Text>
                                                                    </HStack>
                                                                </Box>
                                                            }

                                                            <Box mb='3'>
                                                                <HStack mt='4' spacing='1' alignItems='end' display={'flex'}>
                                                                    <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='1' >$</Heading>
                                                                    <Heading color="#002EFF" className="Subtitle" size='2xl' lineHeight='0.9'>{target.precio}</Heading>
                                                                    <Heading color="#002EFF" className="Subtitle" size='lg' lineHeight='1' >/mes</Heading>
                                                                </HStack>
                                                                <Text className="Subtitle" fontSize='sm' color='#66686C'>{target.tiempoDcto} luego ${target.precioNormal}/mes</Text>
                                                            </Box>

                                                            <Button 
                                                                onClick={() => openSlide('tarjeta', target.id, 'Movil', `${target.gigas}${target.gigas2 ? ` ${target.gigas2}` : ''}`, target.precio, target.precioNormal, target.dcto, target?.planid)}
                                                                w="100%" 
                                                                p="5" 
                                                                bg="#002EFF"
                                                                data-planid={target.planid}
                                                                data-plan={`${target.gigas} ${target.gigas2}`}
                                                                data-planprecio={target.precio.replace('.', '')}
                                                                data-plansubprecio={target.precioNormal.replace(/[$.]/g, '')}
                                                                data-posicion={target.id}
                                                                data-oferta={target.dcto ? target.dcto.replace('%', ' porciento dcto') : 'no aplica'}
                                                                data-mercado='pe'
                                                                data-segmento='po'
                                                                mt={{base: '0', md: '2'}} 
                                                                color="white" 
                                                                border='1px solid #002EFF'
                                                                mx="auto"
                                                                _hover={{background:"white", color:"#002EFF", border:"1px solid #002EFF"}} 
                                                                borderRadius="30" 
                                                                className="General gtm_planes_btn_cta"
                                                            >
                                                                <Text fontSize="md">Lo quiero</Text>
                                                            </Button>
                                                        </Box>

                                                        {/* Mostrar más detalle */}
                                                        <Flex justifyContent='center' my='4'>
                                                            <Button variant='link' _focusVisible={{}} _hover={{}} _active={{}} onClick={onToggle} className="SemiBold" color='#002EFF' rightIcon={isOpen ? <BsChevronUp /> : <BsChevronDown />}>
                                                                {isOpen ? 'Ocultar detalle' : 'Mostrar detalle'}
                                                            </Button>
                                                        </Flex>

                                                        <Collapse in={isOpen} animateOpacity>
                                                            <VStack
                                                                divider={<StackDivider borderColor='gray.200' />}
                                                                spacing={3}
                                                                align='stretch'
                                                                px="5"
                                                                py="3"
                                                            >
                                                                {
                                                                    target.items.map((beneficios) => (
                                                                        <HStack spacing='10px' key={beneficios.id}>
                                                                            <Box w="10%">
                                                                                {beneficios.icon}
                                                                            </Box>
                                                                            <Box w="90%">
                                                                                {
                                                                                    beneficios.id === 1 && <Flex align='center'>
                                                                                        <Flex bg='#F3F5FF' border='1px solid #002EFF' px='2' align='center' gap='5px' borderRadius='5px'>
                                                                                            <IconSatelite size='14' />
                                                                                            <Text fontSize='sm'>Cobertura satelital*</Text>
                                                                                        </Flex>
                                                                                        <Tooltip hasArrow placement="top" label='La cobertura satelital con Starlink se activa en lugares donde no hay señal móvil disponible'>
                                                                                            <IconButton isRound variant='ghost' size='sm' icon={<IoInformationCircleOutline size='17px' />} />
                                                                                        </Tooltip>
                                                                                    </Flex>
                                                                                }
                                                                                <Text fontSize="sm" textAlign="justify" className="Subtitle" dangerouslySetInnerHTML={{__html:beneficios.info}}></Text>
                                                                            </Box>
                                                                        </HStack>
                                                                    ))
                                                                }
                                                            </VStack>
                                                        </Collapse>
                                                    </Box>

                                                    {/* Footer Target */}
                                                    <Flex bg='#F3F5FF' alignItems='center' mt='2' gap='3' py='2' px='4' borderRadius='10' spacing='1'>
                                                        <IconUsuarios size='14' />
                                                        <Text className="Subtitle" fontSize={['xs','xs','sm','sm','sm']}>
                                                            Líneas adicionales por <b>${target.valorPlanesAdicionalesNormal}</b>c/u
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                            </SplideSlide>
                                        :   
                                            <SplideSlide key={target.id}>
                                                <Box key={target.id} bg='white' p='1px' borderRadius='10'>
                                                    <Box border='1px solid #BBB' borderRadius="10" width='340px'>
                                                        {/* Cobertura Satelital */}
                                                        {/* <Flex justify='end' pt='3' pr='3'>
                                                            <Flex align='center' gap='5px' px='2' bg='#F3F5FF' border='1px solid #0022BF' borderRadius='5px'>
                                                                <IconSatelite size='12' />
                                                                <Text className='General' fontSize='sm'>Cobertura Satelital</Text>
                                                            </Flex>
                                                        </Flex> */}
                                                                
                                                        {
                                                            target?.millas
                                                                ? <Flex justify='end' pt='3' pr='3'>
                                                                    <Text className="General" bg='#4C44B7' color='white' fontSize='sm' px='2' border='1px solid #4C44B7' borderRadius='5px'>
                                                                        {target?.millas} Millas LATAM Pass
                                                                    </Text>
                                                                </Flex>
                                                                : ''
                                                        }

                                                        {/* Header Target */}
                                                        <Box px="4" pt="4" borderRadius="10" display={'block'}>
                                                            <Heading className="Subtitle" textAlign='left' fontSize='2xl'>
                                                                Plan {target.gigas} {target.gigas2}
                                                            </Heading>
                                                        </Box>

                                                        {/* Body Target */}
                                                        <Box px="4" mb="3">
                                                            {
                                                                target.precioNormal
                                                                && <Box display={'block'}>
                                                                    <HStack mt='2' spacing='0' >
                                                                        <Text border='1px solid #42E8B4' color='black' bg='#42E8B4' px='2' className="Title" h='auto' lineHeight='1.1' borderLeftRadius='4px'>
                                                                            {target.dcto} dcto.
                                                                        </Text>
                                                                        <Text border='1px solid #42E8B4' px='2' className="Title" lineHeight='1.1' borderRightRadius='4px'>
                                                                            Oferta Online
                                                                        </Text>
                                                                    </HStack>
                                                                </Box>
                                                            }

                                                            <Box mb='3'>
                                                                <HStack mt={4} spacing='1' alignItems='end' display={'flex'}>
                                                                    <Heading color="#002EFF" className="Subtitle" size='xl' lineHeight='1' >$</Heading>
                                                                    <Heading color="#002EFF" className="Subtitle" size='2xl' lineHeight='0.9'>{target.precio}</Heading>
                                                                    <Heading color="#002EFF" className="Subtitle" size='lg' lineHeight='1' >/mes</Heading>
                                                                </HStack>
                                                                {
                                                                    target.precioNormal && <Text className="General" fontSize='sm' color='#66686C'>{target.tiempoDcto} luego ${target.precioNormal}/mes</Text>
                                                                }
                                                            </Box>

                                                            <Button 
                                                                onClick={() => openSlide('tarjeta', target.id, 'Movil', `${target.gigas}${target.gigas2 ? ` ${target.gigas2}` : ''}`, target.precio, target.precioNormal, target.dcto, target?.planid)}
                                                                w="100%" 
                                                                p="5" 
                                                                bg="#002EFF"
                                                                data-planid={target.planid}
                                                                data-plan={`${target.gigas} ${target.gigas2}`}
                                                                data-planprecio={target.precio.replace('.', '')}
                                                                data-plansubprecio={target.precioNormal.replace(/[$.]/g, '')}
                                                                data-posicion={target.id}
                                                                data-oferta={target.dcto ? target.dcto.replace('%', ' porciento dcto') : 'no aplica'}
                                                                data-mercado='pe'
                                                                data-segmento='po'
                                                                mt={{base: '0', md: '2'}} 
                                                                color="white" 
                                                                border='1px solid #002EFF'
                                                                mx="auto"
                                                                _hover={{background:"white", color:"#002EFF", border:"1px solid #002EFF"}} 
                                                                borderRadius="30" 
                                                                className="General gtm_planes_btn_cta"
                                                            >
                                                                <Text fontSize="md">Lo quiero</Text>
                                                            </Button>
                                                        </Box>

                                                        {/* Mostrar más detalle */}
                                                        <Flex justifyContent='center' my='4'>
                                                            <Button variant='link' _focusVisible={{}} _hover={{}} _active={{}} onClick={onToggle} className="SemiBold" color='#002EFF' rightIcon={isOpen ? <BsChevronUp /> : <BsChevronDown />}>
                                                                {isOpen ? 'Ocultar detalle' : 'Mostrar detalle'}
                                                            </Button>
                                                        </Flex>
                                                        <Collapse in={isOpen} animateOpacity>
                                                            <VStack
                                                                divider={<StackDivider borderColor='gray.200' />}
                                                                spacing={3}
                                                                align='stretch'
                                                                px="5"
                                                                py="3"
                                                            >
                                                                {
                                                                    target.items.map((beneficios) => (
                                                                        <HStack spacing='10px' key={beneficios.id}>
                                                                            <Box w="10%">
                                                                                {beneficios.icon}
                                                                            </Box>
                                                                            <Box w="90%">
                                                                                {
                                                                                    beneficios.id === 1 && <Flex align='center'>
                                                                                        <Flex bg='#F3F5FF' border='1px solid #002EFF' px='2' align='center' gap='5px' borderRadius='5px'>
                                                                                            <IconSatelite size='14' />
                                                                                            <Text fontSize='sm'>Cobertura satelital*</Text>
                                                                                        </Flex>
                                                                                        <Tooltip hasArrow placement="top" label='La cobertura satelital con Starlink se activa en lugares donde no hay señal móvil disponible'>
                                                                                            <IconButton isRound variant='ghost' size='sm' icon={<IoInformationCircleOutline size='17px' />} />
                                                                                        </Tooltip>
                                                                                    </Flex>
                                                                                }
                                                                                <Text fontSize="sm" textAlign="justify" className="Subtitle" dangerouslySetInnerHTML={{__html:beneficios.info}}></Text>
                                                                            </Box>
                                                                        </HStack>
                                                                    ))
                                                                }
                                                            </VStack>
                                                        </Collapse>
                                                    </Box>

                                                    {/* Footer Target */}
                                                    <Flex bg='#F3F5FF' alignItems='center' mt='2' gap='3' py='2' px='4' borderRadius='10' spacing='1'>
                                                        <IconUsuarios size='14' />
                                                        <Text className="Subtitle" fontSize={['xs','xs','sm','sm','sm']}>
                                                            Líneas adicionales por <b>${target.valorPlanesAdicionalesNormal}</b>c/u
                                                        </Text>
                                                    </Flex>
                                                </Box>
                                            </SplideSlide>
                                    )
                                })
                            }
                        </SplideTrack>

                        <div className="splide__arrows">
                            <button className="splide__arrow splide__arrow--prev arrow-next" type='button' >
                                <IconArrowRight size='5px' />
                            </button>
                            <button className="splide__arrow splide__arrow--next arrow-next" type='button' aria-label="Next slide" aria-controls="splide02-track">
                                <IconArrowRight size='5px' />
                            </button>
                        </div>
                    </Splide>
                </Box>

                {/* Info down */}
                <Box backgroundImage={[MovilDownMovil,MovilDownMovil, MovilDown]} backgroundSize="cover" backgroundRepeat="no-repeat" my={[0,0,10,10,10]}>
                    <Box w={['90%','90%','90%','90%','90%']} m='auto' pt={[5,5,20,20,20]}>
                        <Heading fontWeight='500' className="General" size='2xl' color='white' lineHeight='1.2'>
                            ¿Por qué contratar <br /> <b>Planes Móviles Entel?</b>
                        </Heading>
                    </Box>

                    <Box w={['90%','90%','90%','90%','90%']} m='auto' pb={[8,8,16,16,16]} pt={[20,20,10,10,10]}>
                        <Splide
                            hasTrack={false}
                            options={{
                                type: 'loop',
                                perPage: 3,
                                perMove: 1,
                                pagination: true,
                                autoplay: false,
                                gap: '30px',
                                arrows: false,
                                breakpoints: {
                                    840: {
                                        perPage: 2,
                                    },
                                    600: {
                                        perPage: 1,
                                    }
                                },
                            }}
                        >
                            <SplideTrack>
                                <SplideSlide>
                                    <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                        <IconTeSumo color='#002EFF' size='40px' />
                                        <Heading className="Title" size='md' mt='3'>
                                            Planes Te Sumo
                                        </Heading>
                                        <Text className="Subtitle" mt='2' fontSize='lg'>
                                            Agrega planes adicionales a tu línea titular con las mismas gigas, minutos y SMS que tu plan.
                                        </Text>
                                    </Box>
                                </SplideSlide>
                                <SplideSlide>
                                    <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                        <IconRoaming color='#002EFF' size='40px' />
                                        <Heading className="Title" size='md' mt='3'>
                                            Roaming Entel
                                        </Heading>
                                        <Text className="Subtitle" mt='2' fontSize='lg'>
                                            Los planes con Roaming incluyen mensualmente hasta 10GB de navegación y Whatsapp libre.
                                        </Text>
                                    </Box>
                                </SplideSlide>
                                <SplideSlide>
                                    <Box bg='white' p='5' borderRadius='12px' h='100%'>
                                        <Icon5G size='40px' />
                                        <Heading className="Title" size='md' mt='3'>
                                            Cobertura 5G
                                        </Heading>
                                        <Text className="Subtitle" mt='2' fontSize='lg'>
                                            ¡Más velocidad! Para todo lo que quieras sin costo adicional.
                                        </Text>
                                    </Box>
                                </SplideSlide>
                            </SplideTrack>
                        </Splide> 
                    </Box>
                </Box>
            </Box>

            {/* Abrir modal */}
            {
                openSlideModal && 
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        priceTyc={precioNormalSolicitado}
                        openSlideModal={openSlideModal} 
                        descuento={descuentoPlan}
                        price={precioSolicitado}
                        valuePhoneInitial={''}
                        plan={planSolicitado}
                        typePlanSelected={typePlan}
                        submitInitial={false}
                        seccion="Movil"
                        view={isBanner ? 'banner' : 'plan'}
                        id={id}
                    />
                </Box>
            }
        </>
    )
}

export default Movil